
export default {
  name: "ContentType4",
  props: {
    introList: {
      type: Array,
      default () {
        return []
      }
    },
    imageList: {
      type: Array,
      default () {
        return []
      }
    },
    contentStyle: {
      type: Object,
      default () {
        return {}
      }
    },
    isHaveImgClass: {
      type: Boolean,
      default:true
    },
    imgClassName:{
      type:String,
      default:''
    },
    hspace:{
      type:Number,
      default:5,
    },
    vspace:{
      type:Number,
      default:5,
    },
    classProps: {
      type: String,
      default: ''
    }
  }
}
